exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Login{font-size:16px;padding:20px}.Login a{margin:0 10px}.Login a:active,.Login a:hover,.Login a:link,.Login a:visited{color:#2d5da5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../src/components/login/index.scss
// module id = 667
// module chunks = 0